import * as Yup from 'yup';

export const loginFormValidation = Yup.object().shape({
  username: Yup.string().min(2, "Your username must contain at least 2 characters")
    .required("You need to enter your TVBIZZ username!"),
  password: Yup.string().min(6, "Your password must contain at least 6 characters")
    .required("You need to enter your TVBIZZ password!")
})
